/** @format */

import axios from 'axios'

import { notification } from 'antd'

import { ENV_COUNTRY, ENV_FUNCTION_USER } from '../../../hooks/enviroment'

export default async function userRegister(item) {
	return await axios({
		method: 'POST',
		url: `${ENV_FUNCTION_USER}/user/create/${ENV_COUNTRY}`,
		data: {
			email: item.email,
			first_name: item.first_name,
			last_name: item.last_name,
			password: item.password,
		},
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				notification['success']({
					message: `Bienvenido al Panel Administrativo`,
					description: `Estas a solo un paso de terminar el registro, revisa tu correo Electrónico...`,
					duration: 15,
				})
				return true
			} else {
				notification['error']({
					message: `Error al intentar registrarse`,
					description: `${response.data.message}`,
				})
				return false
			}
		})
		.catch((error) => {
			notification['error']({
				message: `Error Servicio ${error.response.status}`,
				description: `${ENV_FUNCTION_USER}/user/create/${ENV_COUNTRY}`,
			})
		})
}
